<! --
/**
* SuiteCRM is a customer relationship management program developed by SalesAgility Ltd.
* Copyright (C) 2021 SalesAgility Ltd.
*
* This program is free software; you can redistribute it and/or modify it under
* the terms of the GNU Affero General Public License version 3 as published by the
* Free Software Foundation with the addition of the following permission added
* to Section 15 as permitted in Section 7(a): FOR ANY PART OF THE COVERED WORK
* IN WHICH THE COPYRIGHT IS OWNED BY SALESAGILITY, SALESAGILITY DISCLAIMS THE
* WARRANTY OF NON INFRINGEMENT OF THIRD PARTY RIGHTS.
*
* This program is distributed in the hope that it will be useful, but WITHOUT
* ANY WARRANTY; without even the implied warranty of MERCHANTABILITY or FITNESS
* FOR A PARTICULAR PURPOSE. See the GNU Affero General Public License for more
* details.
*
* You should have received a copy of the GNU Affero General Public License
* along with this program.  If not, see http://www.gnu.org/licenses.
*
* In accordance with Section 7(b) of the GNU Affero General Public License
* version 3, these Appropriate Legal Notices must retain the display of the
* "Supercharged by SuiteCRM" logo. If the display of the logos is not reasonably
* feasible for technical reasons, the Appropriate Legal Notices must display
* the words "Supercharged by SuiteCRM".
*/
-->
<div>
    <div class="dropdown-submenu-items-container">
        <a (click)="isCollapsed = !isCollapsed"
           class="dropdown-submenu-parent-button dropdown-item dropdown-toggle"
        >
            <scrm-image *ngIf="item && item.icon" [image]="item.icon"></scrm-image>
            {{item && item.label}}
        </a>
        <div *ngIf="item && item.items.length" [ngbCollapse]="isCollapsed">
            <ul class="dropdown-submenu pl-2 mb-1">

                <li *ngFor="let subItem of item.items" class="dropdown-submenu-item dropdown-item">

                    <a class="action-link dropdown-submenu-item-link"
                       [ngClass]="subItem && subItem.klass"
                       (click)="click(subItem)">
                        <scrm-image *ngIf="subItem.icon" [image]="subItem.icon"></scrm-image>
                        {{subItem && subItem.label}}
                    </a>
                </li>
            </ul>
        </div>
    </div>
    <div class="dropdown-submenu-extra">
        <ng-content></ng-content>
    </div>
</div>
